import { useHead } from '@unhead/vue';
import { computed, type MaybeRefOrGetter, toValue } from 'vue';

import {
  shouldEmitSrpJsonLd,
  type SrpJsonLdGraph,
  toJsonLdScript,
} from '@/helpers/SEO/buildSrpJsonLdGraph';

export interface SrpJsonLdHeadInput {
  isIndexable: MaybeRefOrGetter<boolean>;
  locationCount: MaybeRefOrGetter<number>;
  isLoading: MaybeRefOrGetter<boolean>;
  hasResults: MaybeRefOrGetter<boolean>;
  canonicalUrl: MaybeRefOrGetter<string>;
  pageTitle: MaybeRefOrGetter<string>;
  pageDescription: MaybeRefOrGetter<string>;
  blockEmission?: MaybeRefOrGetter<boolean>;
  buildGraph: () => SrpJsonLdGraph;
}

/** Registers one reactive `application/ld+json` script when emission gates pass. */
export function useSrpJsonLdHead(input: SrpJsonLdHeadInput): void {
  useHead({
    script: computed(() => {
      if (toValue(input.blockEmission)) {
        return [];
      }

      if (
        !shouldEmitSrpJsonLd({
          isIndexable: toValue(input.isIndexable),
          locationCount: toValue(input.locationCount),
          isLoading: toValue(input.isLoading),
          hasResults: toValue(input.hasResults),
          canonicalUrl: toValue(input.canonicalUrl),
          pageTitle: toValue(input.pageTitle),
          pageDescription: toValue(input.pageDescription),
        })
      ) {
        return [];
      }

      return toJsonLdScript(input.buildGraph());
    }),
  });
}
